import { Supplier } from "../types/supplier";
import { get, post } from "./fetch.core";

async function add(data: Supplier) {
  const rst = await post("/admin/supplier/create", data);

  return rst.data;
}

async function single(id: string) {
  const res = await get<Supplier>(`/admin/supplier/single?id=${id}`);
  return res.data;
}

async function deleteRecord(id: string) {
  const res = await post("/admin/supplier/delete", { id });

  return res.data;
}

async function list() {
  const res = await get<Supplier[]>("/admin/supplier/list");

  return res.data;
}

async function update(data: Supplier) {
  const res = await post("/admin/supplier/update", data);

  return res.data;
}

const suplierCore = {
  add,
  single,
  deleteRecord,
  update,
  list,
};

export default suplierCore;
